import { render, staticRenderFns } from "./OtoIcon.vue?vue&type=template&id=14c9cf00"
import script from "./OtoIcon.vue?vue&type=script&lang=js"
export * from "./OtoIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports